//swipe gesture directive
export default {
	mounted(el, binding) {
		let startX = 0;
		let currentX = 0;
		let isSwipingRight = false;
		let translateX = 0;
		let endingAnimation = false;
		let touchEndTimeout = null;

		const touchStart = (e) => {
			if (!endingAnimation) {
				startX = e.touches[0].clientX;
				currentX = startX;
				touchEndTimeout = setTimeout(forceEndSwipe, 2000);
			}
		};

		const touchMove = (e) => {
			if (!endingAnimation) {
				currentX = e.touches[0].clientX;
				isSwipingRight = startX > currentX;
				translateX = currentX - startX;
				if(isSwipingRight) {
					translateX = Math.min(0, translateX);
				} else {
					translateX = Math.max(0, translateX);
				}

				if(binding.value && typeof binding.value === 'function') {
					binding.value(false, isSwipingRight, translateX);
				}

				if (touchEndTimeout) {
					clearTimeout(touchEndTimeout);
					touchEndTimeout = setTimeout(forceEndSwipe, 2000);
				}
			}
		};

		const touchEnd = () => {
			if (!endingAnimation) {
				const threshold = 130;
				if (Math.abs(startX - currentX) > threshold) {
					endingAnimation = true;

					// You can call a method passed through the directive's binding
					if(binding.value && typeof binding.value === 'function') {
						binding.value(true, isSwipingRight, translateX);
					}

					setTimeout(() => {
						translateX = 0;
						if(binding.value && typeof binding.value === 'function') {
							binding.value(false, isSwipingRight, 0);
						}
						endingAnimation = false;
					}, 500);

				} else {
					translateX = 0;
					if(binding.value && typeof binding.value === 'function') {
						binding.value(false, isSwipingRight, 0);
					}
				}

				if (touchEndTimeout) {
					clearTimeout(touchEndTimeout);
				}
			}
		};

		const forceEndSwipe = () => {
			translateX = 0;
			if(binding.value && typeof binding.value === 'function') {
				binding.value(false, isSwipingRight, 0);
			}
		};

		// Attach event listeners
		el.addEventListener('touchstart', touchStart);
		el.addEventListener('touchmove', touchMove);
		el.addEventListener('touchend', touchEnd);

		// Cleanup function
		el._cleanupSwipe = () => {
			el.removeEventListener('touchstart', touchStart);
			el.removeEventListener('touchmove', touchMove);
			el.removeEventListener('touchend', touchEnd);

			if (touchEndTimeout) {
				clearTimeout(touchEndTimeout);
			}
		};
	},
	unmounted(el) {
		if (el._cleanupSwipe) {
			el._cleanupSwipe();
		}
	}
}